// Per-device settings (this browser profile): which single screen it shows and
// whether queue slips print without asking. Stored locally, because they
// describe the physical device, not the user.
export type DeviceMode = 'reception' | 'doctor' | 'pharmacy' | 'board' | 'full';

const MODE_KEY = 'klx.deviceMode';
const PRINT_KEY = 'klx.autoPrint';

export const MODE_HOME: Record<DeviceMode, string> = { reception: '/reception', doctor: '/queue', pharmacy: '/dispense', board: '/board', full: '/reception' };

export function getDeviceMode(): DeviceMode | null {
  // board.klinixis.com is always the waiting-room display; no chooser needed on a TV.
  if (typeof location !== 'undefined' && location.hostname.startsWith('board.')) return 'board';
  try { const v = localStorage.getItem(MODE_KEY); return v === 'reception' || v === 'doctor' || v === 'pharmacy' || v === 'board' || v === 'full' ? v : null; } catch { return null; }
}
export function setDeviceMode(m: DeviceMode) { try { localStorage.setItem(MODE_KEY, m); } catch { /* ignore */ } }
export function getAutoPrint(): boolean { try { return localStorage.getItem(PRINT_KEY) === '1'; } catch { return false; } }
export function setAutoPrint(v: boolean) { try { localStorage.setItem(PRINT_KEY, v ? '1' : '0'); } catch { /* ignore */ } }
